import { PartialTranslation } from '../translations';

export const cs: PartialTranslation = {
  newChat: 'Nový chat',
  search: 'Hledat',
  user: 'Uživatel',
  settings: 'Nastavení',
  language: 'Jazyk',
  getHelp: 'Získat pomoc',
  viewAllPlans: 'Zobrazit všechny plány',
  learnMore: 'Dozvědět se více',
  logOut: 'Odhlásit se',
  chooseLanguage: 'Vybrat jazyk',
  chooseYourPreferredLanguage: 'Vyberte svůj preferovaný jazyk',
  searchLanguages: 'Hledat jazyky...',
  autoDetect: 'Automatická detekce',
  noLanguagesFound: 'Žádné jazyky nenalezeny',
  askAnything: 'Zeptejte se na cokoliv',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Osobní',
  freePlan: 'Bezplatný plán',
  current: 'Aktuální',
  close: 'Zavřít',
  archive: 'Archivovat',
  delete: 'Smazat',
  confirmDelete: 'Jste si jisti, že chcete tento chat smazat?',
  confirmArchive: 'Jste si jisti, že chcete tento chat archivovat?',
  deleteCannotUndo: 'Tuto akci nelze vrátit zpět.',
  archiveCanFind: 'Najdete jej v seznamu archivů po archivaci.',
  
  // 资源面板
  resources: 'Zdroje',
  addResource: 'Přidat zdroj',
  deleteResource: 'Smazat zdroj',
  noMatchingResourcesFound: 'Nenalezeny žádné odpovídající zdroje',
  noResourcesAvailable: 'Žádné zdroje nejsou k dispozici',
  hideResources: 'Skrýt zdroje',
  showResources: 'Zobrazit zdroje',
  
  // 聊天输入框
  typeMessage: 'Napište zprávu...',
  thinkingOptions: 'Možnosti myšlení',
  deleteFile: 'Smazat soubor',
  clearSelection: 'Vymazat výběr',
  addAttachment: 'Přidat přílohu',
  sendMessage: 'Odeslat zprávu',
  
  // 思考模式选项
  deepInsight: 'Hluboký vhled · Povrchová analýza',
  deepInsightDesc: 'Rychlé pochopení klíčových bodů',
  deepExploration: 'Hluboký průzkum · Komplexní analýza',
  deepExplorationDesc: 'Vícerozměrný hloubkový výzkum',
  deepDeconstruction: 'Hluboká dekonstrukce · Systematický argument',
  deepDeconstructionDesc: 'Vrstva po vrstvě progresivní analýza',
  
  // 写作模式选项
  contractReview: 'Kontrola smlouvy · Identifikace rizik',
  contractReviewDesc: 'Analýza klauzulí a kontrola dodržování',
  textPolish: 'Leštění textu · Profesionální vyjadřování',
  textPolishDesc: 'Jazyková optimalizace a strukturální úprava',
  legalDocuments: 'Právní dokumenty · Standardní návrh',
  legalDocumentsDesc: 'Profesionální psaní právních dokumentů',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Přihlásit se',
  register: 'Zaregistrovat se',
  welcomeBack: 'Vítejte v LawHelper',
  loginSubtitle: 'Váš AI Právní Výzkumný Asistent',
  continueWithGoogle: 'Pokračovat s Google',
  continueWithMicrosoft: 'Pokračovat s Microsoft',
  continueWithWeChat: 'Pokračovat s WeChat',
  orContinueWith: 'nebo pokračovat s',
  emailTab: 'E-mail',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Zadejte svůj e-mail',
  phonePlaceholder: 'Zadejte telefonní číslo',
  codePlaceholder: 'Zadejte 6místný kód',
  sending: 'Odesílání...',
  verifying: 'Ověřování...',
  verify: 'Ověřit',
  sendMagicLink: 'Odeslat magický odkaz',
  getVerificationCode: 'Získat kód',
  resendCode: 'Znovu odeslat kód',
  resendIn: 'Znovu odeslat za',
  magicLinkSent: 'Magický odkaz odeslán na váš e-mail',
  magicLinkHint: 'Pošleme vám bezpečný odkaz na váš e-mail',
  otpSent: 'Ověřovací kód odeslán',
  agreeToTerms: 'Pokračováním souhlasíte s našimi',
  privacyPolicy: 'Zásady ochrany osobních údajů',
  termsOfService: 'Podmínky služby',
  and: 'a',
  privacyTitle: 'Vaše soukromí je důležité',
  privacyIntro: 'Používáme cookies a podobné technologie, abychom vám poskytli nejlepší zážitek.',
  essentialCookies: 'Nezbytné cookies',
  essentialDesc: 'Potřebné pro fungování webu',
  analyticsCookies: 'Analytické cookies',
  analyticsDesc: 'Pomáhají nám zlepšovat službu',
  marketingCookies: 'Marketingové cookies',
  marketingDesc: 'Používány pro personalizovaný obsah',
  acceptAll: 'Přijmout vše',
  essentialOnly: 'Pouze nezbytné',
  customize: 'Přizpůsobit',
  savePreferences: 'Uložit nastavení',
  back: 'Zpět',
  readPrivacyPolicy: 'Přečíst naše zásady ochrany osobních údajů',
  cookiePolicy: 'Zásady používání cookies',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI kontrola',
  aiDraft: 'AI návrh',
  smartAssistant: 'Šablona',

  // 知识库搜索
  enableKnowledgeSearch: 'Povolit vyhledávání',
  knowledgeSearchDesc: 'AI hledá ve vašich dokumentech',
  clickToDisable: 'Zakázat',
  clickToEnable: 'Povolit',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Zavřít panel zdrojů',
  uploading: 'Nahrávání %{fileName}...',
  processing: 'Zpracování %{fileName}...',
  uploadSuccess: '✓ %{fileName} nahráno',
  uploadError: '✗ Nahrávání selhalo: %{error}',
  quickAnswer: 'Rychlá odpověď',
  quickAnswerDesc: 'Rychlá odpověď na jednoduché otázky',
  cancelRequest: 'Zrušit',
  library: 'Knihovna',
  filterAll: 'Vše',
  filterChat: 'Chaty',
  filterReview: 'Kontrola',
  filterDraft: 'Koncept',
  filterTemplate: 'Šablona',
  filterForm: 'Formulář',
  thinking: 'Přemýšlím...',
  thinkingProcess: 'Myšlenkový proces',
  analyzingLegalLogic: 'Analyzuji právní logiku...',
  lawhelperThinking: 'Lawhelper přemýšlí...',
  serviceError: 'Chyba služby',
  uploaded: 'Nahráno',
  settingsGeneral: 'Obecné',
  settingsNotifications: 'Oznámení',
  settingsAppearance: 'Vzhled',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Oznámení o odpovědích',
  settingsResponseNotificationsDesc: 'Oznámení po dokončení odpovědi AI',
  settingsColorMode: 'Barevný režim',
  settingsLight: 'Světlý',
  settingsDark: 'Tmavý',
  settingsSystem: 'Systém',
  about: 'O aplikaci',
  reviewTitle: 'Kontrola dokumentu',
  exitReview: 'Ukončit kontrolu',
  uploadPrompt: 'Nahrajte PDF ke kontrole',
  uploadButton: 'Vybrat soubor',
  startChatConfig: 'Napište "Zkontrolovat tento dokument"',
  reviewPlaceholder: 'Napište zprávu nebo "Zkontrolovat dokument"...',
  analyzing: 'Kontroluji...',
  reviewComplete: 'Kontrola dokončena',
  issuesFound: 'Nalezeno %{count} problémů',
  draftTitle: 'Tvorba právního dokumentu',
  draftPlaceholder: 'Upravujte zde nebo nechte AI generovat...',
  analyzingTemplate: 'Analýza šablony %{name}...',
  templateAnalyzed: '✅ Šablona %{name} analyzována!',
  templateAnalysisPrompt: 'Analyzovat klíčové klauzule',
  parsingFailed: '⚠️ Soubor se nepodařilo analyzovat.',
  generating: 'Generuji...',
  generatedSuccess: '✅ Dokument vygenerován!',
  drafterWelcome: 'Vítejte v AI asistentovi dokumentů',
  drafterYouCan: 'Můžete:',
  drafterUploadTemplate: 'Nahrát šablonu k AI analýze',
  drafterDescribeNeeds: 'Popsat požadavky na dokument',
  drafterLetAiHelp: 'AI pomůže se smlouvami, dohodami atd.',
  drafterExamples: 'Příklady:',
  drafterExampleRental: '"Vytvořte nájemní smlouvu"',
  drafterExampleLabor: '"Vyplňte pracovní smlouvu"',
  drafterInputPlaceholder: 'Popište své potřeby...',
  drafterThinking: 'Přemýšlím...',
  drafterHistoryTitle: 'Historie',
  drafterNoHistory: 'Žádná historie',
  drafterNewChat: 'Nový chat',
  drafterHistory: 'Historie',
  drafterRemoveAttachment: 'Odebrat přílohu',
  drafterLineHeight: 'Výška řádku',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export do Word (.docx)',
  drafterExportPdf: 'Export do PDF',
  drafterSave: 'Uložit dokument',
  drafterDownload: 'Stáhnout dokument',
  drafterUndo: 'Zpět',
  drafterRedo: 'Znovu',
  drafterBold: 'Tučné',
  drafterItalic: 'Kurzíva',
  drafterStrike: 'Přeškrtnuté',
  drafterUnderline: 'Podtržené',
  drafterHighlight: 'Zvýraznění',
  drafterLink: 'Vložit odkaz',
  drafterAlignLeft: 'Vlevo',
  drafterAlignCenter: 'Na střed',
  drafterAlignRight: 'Vpravo',
  drafterAlignJustify: 'Do bloku',
  drafterList: 'Seznam',
  drafterBulletList: 'Odrážkový seznam',
  drafterOrderedList: 'Číslovaný seznam',
  drafterTaskList: 'Seznam úkolů',
  drafterOpenResource: 'Otevřít panel zdrojů',
  drafterStopGeneration: 'Zastavit generování',
  drafterAgentMode: 'Režim agenta aktivní',
  drafterAgentModeOn: 'Režim agenta aktivní',
  drafterAgentModeOff: 'Normální režim',
  drafterUploadAttachment: 'Nahrát přílohu',
  drafterExit: 'Ukončit',
  drafterConfirm: 'Potvrdit',
  drafterOpenLink: 'Otevřít odkaz',
  drafterDeleteLink: 'Smazat odkaz',
  drafterQuote: 'Citace',
  workflowTitle: 'AI proces',
  workflowRunning: 'Probíhá...',
  workflowReady: 'Připraven',
  workflowCompleted: 'Dokončen',
  workflowStartFailed: 'Spuštění procesu selhalo',
  workflowExecutionFailed: 'Provedení procesu selhalo',
  workflowInterrupted: 'Proces přerušen',
  workflowProcessing: 'Zpracovávám...',
  workflowStepsCompleted: 'kroků dokončeno',
  workflowStepsTotal: 'Proces dokončen (%{count} kroků)',
  acceptChanges: 'Přijmout změny',
  rejectChanges: 'Odmítnout změny',
  changesAccepted: 'Změny přijaty',
  changesRejected: 'Změny odmítnuty',
  stopWorkflow: 'Zastavit',
  restartWorkflow: 'Restartovat',
  startDrafting: 'Začít tvořit',
  interrupt: 'Zastavit',
  documentSubject: 'Předmět dokumentu *',
  documentType: 'Typ dokumentu',
  jurisdiction: 'Jurisdikce',
  specialRequirements: 'Zvláštní požadavky (volitelné)',
  clickStartDrafting: 'Klikněte "Začít tvořit"',
  docTypeContract: 'Smlouva',
  docTypeAgreement: 'Dohoda',
  docTypeNotice: 'Oznámení',
  docTypeLetter: 'Dopis',
  docTypePetition: 'Petice',
  docTypeWill: 'Závěť',
  docTypePowerOfAttorney: 'Plná moc',
  countryChina: 'Čína',
  countryUSA: 'USA',
  countryGermany: 'Německo',
  countryJapan: 'Japonsko',
  countryFrance: 'Francie',
  countryUK: 'Velká Británie',
  citationVerified: 'Ověřeno',
  citationUnverified: 'Neověřeno',
  imageLoadFailed: 'Obrázek se nepodařilo načíst',
  smartDocTitle: 'Chytrý asistent dokumentů',
  smartDocChatTitle: 'AI asistent dokumentů',
  smartDocDropPrompt: 'Přetáhněte PDF sem',
  smartDocSelectFile: 'Vybrat soubor',
  smartDocOr: 'nebo',
  smartDocWelcomeTitle: 'Vítejte v AI asistentovi',
  smartDocWelcomeYouCan: 'Můžete:',
  smartDocUploadForAI: 'Nahrát šablonu',
  smartDocDescribeDoc: 'Popsat požadavky',
  smartDocLetAIDraft: 'AI pomůže se smlouvami',
  smartDocExamples: 'Příklady:',
  smartDocExampleRental: '"Vytvořte nájemní smlouvu"',
  smartDocExampleLabor: '"Vyplňte pracovní smlouvu"',
  smartDocInputPlaceholder: 'Popište potřeby...',
  smartDocRemoveAttachment: 'Odebrat přílohu',
  smartDocOpenResources: 'Otevřít zdroje',
  smartDocExit: 'Ukončit',
  reviewStartFailed: 'Spuštění kontroly selhalo',
  reviewFailed: 'Kontrola selhala',
  reviewFoundIssues: 'Kontrola dokončena, %{count} problémů.',
  cannotReadStream: 'Nelze číst datový proud',
  parseEventFailed: 'Nelze analyzovat událost',
  errorPrefix: 'Chyba',
  unknownError: 'Neznámá chyba',
  file: 'Soubor',
  loading: 'Načítání...',
  localFolders: 'Místní složky',
  selectLocalFolder: 'Vybrat místní složku',
  reselectFolder: 'Změnit složku',
  addToContext: 'Přidat do chatu',
  saveFile: 'Uložit',
  renameFile: 'Přejmenovat',
  fileSaved: 'Soubor uložen',
  fileRenamed: 'Soubor přejmenován na %{name}',
  browserNotSupported: 'Váš prohlížeč nepodporuje přístup ke složkám',
  noFolderSelected: 'Vyberte složku',
  scanningFolder: 'Skenování složky...',
  selectFileToPreview: 'Vyberte soubor k náhledu',
  aiAnalyze: 'AI analýza',
};
